const actors = [
  {
    id: '',
    name: 'Todos los Roles'
  },

  {
    id: 2,
    name: 'Administrador'
  },

  {
    id: 0,
    name: 'Alumno'
  },

  {
    id: 7,
    name: 'Instructor'
  },

  {
    id: 1,
    name: 'Profesor'
  }
]

export default actors
